import { Stepper } from 'components/UI'
import { approvalActions } from 'ducks/actions'
import { ApprovalValue } from 'ducks/approval/types'
import { useAppDispatch } from 'ducks/hooks'
import { getApprovalStep } from 'ducks/selectors'
import { useSelector } from 'react-redux'
import Step1SecondaryHomeowner from './Step1/Step1Secondary'
import Step2SecondaryHomeowner from './Step2/Step2Secondary'

const HomeownerSecondApprovalStepper = () => {
  const dispatch = useAppDispatch()
  const activeStep = useSelector(getApprovalStep)

  const steps = [
    {
      content: <Step1SecondaryHomeowner />,
    },
    {
      content: <Step2SecondaryHomeowner />,
      disableBack: true,
      // actionNext: () => setIsFinished(true),
    },
  ]

  

  return (
    <>
      <Stepper
        steps={steps}
        activeStep={activeStep}
        setActiveStepAction={(step: number) =>
          dispatch(approvalActions.setApprovalStep(step))
        }
        saveNewValueAction={(value: ApprovalValue) =>
          dispatch(approvalActions.setApprovalValue(value))
        }
        //className={classes.stepper}
      />
    </>
  )
}

export default HomeownerSecondApprovalStepper
